import { render } from "./file-card.vue?vue&type=template&id=47efd30e"
import script from "./file-card.vue?vue&type=script&lang=js"
export * from "./file-card.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__